import React from "react";
import { Container, Row, Col, Card, CardTitle, CardText } from "reactstrap";

interface Contributor {
  name: string;
  github: string;
  email: string;
}

const contributors: Contributor[] = [
  {
    name: "Andrew Stevens",
    github: "StevoLOKE",
    email: "andrew.stevens@loke.com.au",
  },
  {
    name: "Chiedozie Ihejirika",
    github: "dozikal",
    email: "dozie.ihejirika@loke.com.au",
  },
  {
    name: "Dennis Williams",
    github: "denwilliams",
    email: "dennis.williams@loke.com.au",
  },
  {
    name: "Dominic Smith",
    github: "smithamax",
    email: "dominic.smith@loke.com.au",
  },
  {
    name: "Sash Petrovski",
    github: "codevski",
    email: "sash.petrovski@loke.com.au",
  },
  {
    name: "Midhil Kari",
    github: "midhilkari",
    email: "midhil.kari@loke.com.au",
  },
  {
    name: "Errol Hassall",
    github: "Errol-Hassall",
    email: "errol.hassall@loke.com.au",
  },
  {
    name: "Sara Shanmugham",
    github: "eyewinz",
    email: "sara.shanmugham@loke.com.au",
  },
  {
    name: "Brayden Lowing",
    github: "braydenlowing",
    email: "brayden.lowing@loke.com.au",
  },
  {
    name: "Sam Komesarook",
    github: "SamKomesarook",
    email: "sam.komesarook@loke.com.au",
  },
  {
    name: "Shourya Raj",
    github: "shouryaraj",
    email: "shourya.raj@loke.com.au",
  },
  {
    name: "Sahil Jaidka",
    github: "jaidkasahil",
    email: "sahil.jaidka@loke.com.au",
  },
  {
    name: "Hanson Lynn",
    github: "hansl2",
    email: "hanson.lynn@loke.com.au",
  },
  {
    name: "Dimple Patel",
    github: "Dimple65",
    email: "dimple.patel@loke.com.au",
  },
  {
    name: "Michael Gambold",
    github: "michaelgambold",
    email: "michael.gambold@loke.com.au",
  },
  {
    name: "Alex Althoff",
    github: "althoff0",
    email: "alex.althoff@loke.com.au",
  },
  {
    name: "Jarrod Monk",
    github: "jarrodloke",
    email: "jarrod.monk@loke.com.au",
  },
  {
    name: "Jett Jackson",
    github: "j-tt",
    email: "jett.jackson@loke.com.au",
  },
  {
    name: "Jacob Sanderson",
    github: "THEjacob1000",
    email: "jacob.sanderson@loke.com.au",
  },
  {
    name: "Peter Newman",
    github: "peter-newman-loke",
    email: "peter.newman@loke.com.au",
  },
  {
    name: "Zachary Gatt",
    github: "zgatt-loke",
    email: "zachary.gatt@loke.com.au",
  },

  {
    name: "Blake Boughton",
    github: "MrDwarf7",
    email: "blake.boughton@loke.com.au",
  },
];

function ContributorCard(props: { contributor: Contributor }) {
  const { contributor: c } = props;
  return (
    <div className="card-container">
      <Card body>
        <CardTitle>{c.name}</CardTitle>
        <CardText>
          <a href={`mailto:${c.email}`}>{c.email}</a>
        </CardText>
        <a href={`https://github.com/${c.github}`} className="btn btn-primary">
          Github
        </a>
      </Card>
      <style jsx>{`
        .card-container {
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
}

export default function ContributorsPage() {
  return (
    <Container>
      <Row className="mt-4">
        {contributors.map((c) => (
          <Col key={c.email} sm={"4"}>
            <ContributorCard contributor={c} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}
